import * as React from 'react';
import { ContentLoader } from '../Loader';
import { rem } from 'polished';
import styled, { css } from 'styled-components';
const MIN_HEIGHT = 16;
const Wrapper = styled.div `
  overflow: hidden;
  display: inline-block;
  max-width: 100%;
  ${({ $width, $height }) => css `
    width: ${$width};
    height: ${$height};
  `};
`;
const Loader = styled(ContentLoader) `
  height: 100%;
  width: 100%;
  min-height: ${MIN_HEIGHT}px;
  min-width: ${MIN_HEIGHT}px;
`;
const NoImage = styled('div') `
  height: 100%;
  width: 100%;
  min-height: ${MIN_HEIGHT}px;
  min-width: ${MIN_HEIGHT}px;

  ${({ theme }) => css `
    box-shadow: inset 0 0 ${rem(0)} ${rem(2)} ${theme.separatorColor};
  `}
  &:after,
    &:before {
    content: '';
    position: absolute;
    transform: rotate(45deg);
    left: 0;
    right: 0;
    height: ${rem(2)};
    top: 50%;
    background: ${({ theme }) => theme.separatorColor};
  }

  &:before {
    transform: rotate(-45deg);
  }

  position: relative;
  vertical-align: middle;
`;
const Img = styled.img `
  max-width: 100%;
  ${({ $isLoading }) => $isLoading &&
    css `
      width: 1;
      height: 1;
    `}
`;
const ImageComponent = ({ className, src, fallbackSrc, alt, height, width, loading, sizes, srcset, onLoadComplete, }) => {
    const [isFetching, setIsFetching] = React.useState(false);
    const [loadedSrc, setLoadedSrc] = React.useState('');
    const [isError, setIsError] = React.useState(false);
    React.useEffect(() => {
        if (!src) {
            return;
        }
        setIsError(false);
        setIsFetching(true);
        const preloadImage = new Image();
        preloadImage.onload = (e) => {
            const img = e.currentTarget;
            setLoadedSrc(img.src);
            setIsFetching(false);
            if (onLoadComplete) {
                onLoadComplete({
                    naturalHeight: img.naturalHeight,
                    naturalWidth: img.naturalWidth,
                });
            }
        };
        preloadImage.onerror = (e) => {
            setIsFetching(false);
            setIsError(true);
        };
        preloadImage.src = src;
    }, [src, onLoadComplete]);
    const heightParsed = height && !Number.isNaN(Number(height)) ? `${height}px` : height;
    const widthParsed = width && !Number.isNaN(Number(width)) ? `${width}px` : width;
    const ErrorElement = () => {
        return fallbackSrc ? (React.createElement(Img, { src: fallbackSrc, height: heightParsed, width: widthParsed })) : (React.createElement(Wrapper, { title: alt, "$height": heightParsed, "$width": widthParsed },
            React.createElement(NoImage, null)));
    };
    return !src || isError ? (React.createElement(ErrorElement, null)) : isFetching ? (React.createElement(Wrapper, { title: alt, "$height": heightParsed, "$width": widthParsed },
        React.createElement(Loader, null))) : (React.createElement(Img, { className: className, src: loadedSrc, height: heightParsed, width: widthParsed, loading: loading, sizes: sizes, srcSet: srcset, alt: alt }));
};
export default ImageComponent;
